module.exports = __webpack_public_path__ + "static/video4-98f6f9bc69ebd6b9bc9cc9360e488b6e.png";